import React, { useContext } from 'react';
import {
    Box,
    Button, Flex,
    Link,
    Stack,
    Text,
    useColorModeValue,
    useToast
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import { CreativeTimLogo, StarsIcon } from "components/Icons/Icons";
import { Separator } from "components/Separator/Separator";
import { SidebarHelp } from "components/Sidebar/SidebarHelp";
import { NavLink, useLocation } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { marked } from 'marked';

// this function creates the links and collapses that appear in the sidebar (left menu)


const SidebarContent = ({ logoText, routes }) => {

    // to check for active links and opened collapses
  const { sideMessages, 
          setMessages, 
          setResponseMessages,
          setShowSuggestions 
        } = useContext(AppContext);
  console.log("🚀 ~ SidebarContent ~ sideMessagesafsjhasfkljdh:", sideMessages)

  const truncateMessage = (message, maxLength = 23) => {
    if (message.length > maxLength) {
      return message.substring(0, maxLength) + '...';
    }
    return message;
  };
  
  const toast = useToast()
  let location = useLocation();
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});
  const hoverBg = useColorModeValue("gray.100", "gray.700");

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };
  const createLinks = (routes) => {
    // Chakra Color Mode
    const activeBg = useColorModeValue("white", "gray.700");
    const inactiveBg = useColorModeValue("white", "gray.700");
    const activeColor = useColorModeValue("gray.700", "white");
    const inactiveColor = useColorModeValue("gray.400", "gray.400");

    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.category) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <div key={prop.name}>
            <Text
              color={activeColor}
              fontWeight="bold"
              mb={{
                xl: "12px",
              }}
              mx="auto"
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py="12px"
            >
              {document.documentElement.dir === "rtl"
                ? prop.rtlName
                : prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }
      return (
        <NavLink to={prop.layout + prop.path} key={prop.name}>
          {activeRoute(prop.layout + prop.path) === "active" ? (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg={activeBg}
              mb={{
                xl: "12px",
              }}
              mx={{
                xl: "auto",
              }}
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py="12px"
              borderRadius="15px"
              _hover="none"
              w="100%"
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
              }}
              _focus={{
                boxShadow: "none",
              }}
            >
              <Flex>
                {typeof prop.icon === "string" ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                  <IconBox
                    bg="teal.300"
                    color="white"
                    h="30px"
                    w="30px"
                    me="12px"
                  >
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={activeColor} my="auto" fontSize="sm">
                  {prop.name}
                </Text>
              </Flex>
            </Button>
          ) : (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg="transparent"
              mb={{
                xl: "12px",
              }}
              mx={{
                xl: "auto",
              }}
              py="12px"
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              borderRadius="15px"
              _hover="none"
              w="100%"
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
              }}
              _focus={{
                boxShadow: "none",
              }}
            >
              <Flex>
                {typeof prop.icon === "string" ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                  <IconBox
                    bg={inactiveBg}
                    color="teal.300"
                    h="30px"
                    w="30px"
                    me="12px"
                  >
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={inactiveColor} my="auto" fontSize="sm">
                  {prop.name}
                </Text>
              </Flex>
            </Button>
          )}
        </NavLink>
      );
    });
  };

    const links = <>{createLinks(routes)}</>;

    return (
      <Flex
        direction="column"
        h="100vh" 
        position="relative"
      >
        <Box pt={"25px"} mb="12px">
          <Link
            target="_blank"
            display="flex"
            lineHeight="100%"
            mb="30px"
            fontWeight="medium"
            justifyContent="center"
            alignItems="center"
            fontSize="11px"
          >
            <StarsIcon
              cursor="pointer"
              ms={{ base: "16px", xl: "0px" }}
              me="10px"
              w="25px"
              h="25px"
            />
            <Text fontSize="xl" mt="3px" fontWeight="bold">
              GRID AI-1.0
            </Text>
          </Link>
          <Separator></Separator>
        </Box>
    
        <Flex
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
          maxW='100%'
          px="10px"
          mt='30px'>
          <Button
            type='submit'
            bg='white'
            fontSize='14px'
            color='#298BE2'
            fontWeight='bold'
            borderRadius="full"
            borderColor="#298BE2"
            border="1px"
            w='100%'
            h='50'
            mb='24px'
            onClick={() => { 
              setResponseMessages([]);
              setMessages([]);
              setShowSuggestions(true)
            }}
          >
            + New Chat
          </Button>
        </Flex>
    

        <Flex
        direction="column"
        flex="1" 
        minH="0" 
        overflowY="auto"
        overflowX="hidden"
        px="10px"
        mb="10px"
        css={{
          '&::-webkit-scrollbar': {
            width: '6px',
            opacity: 0,
            transition: 'opacity 0.3s',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'transparent',
            borderRadius: '24px',
            transition: 'background 0.3s',
          },
          '&:hover::-webkit-scrollbar-thumb': {
            background: '#a0aec0',
          },
          '&:hover::-webkit-scrollbar-thumb:hover': {
            background: '#718096',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          scrollbarWidth: 'thin',
          scrollbarColor: 'transparent transparent',
          '&:hover': {
            scrollbarColor: '#a0aec0 transparent',
          },
        }}
      >
        {sideMessages.length > 0 && (
          <Text fontWeight="bold" mb="12px" px={2}>
            Today
          </Text>
        )}
        {sideMessages.map((entry, index) => {
          const displayInput =
            entry.user_input && entry.user_input.trim().length > 0
              ? entry.user_input
              : "Image upload";

          return (
            <Box
              key={index}
              cursor="pointer"
              borderRadius="md"
              mx={1}
              mb="2px"
              _hover={{ bg: hoverBg }}
              onClick={() => {
                setMessages([{ text: displayInput }]);
                const formattedResponse = marked(entry.response).replace(/<a /g, '<a target="_blank" ');
                setResponseMessages([formattedResponse]);
                setShowSuggestions(false);
              }}
            >
              <Flex alignItems="center" p={2}>
                <Text 
                  fontSize="md" 
                  id="textContentDiv"
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  maxWidth="100%"
                >
                  {truncateMessage(displayInput)}
                </Text>
              </Flex>
            </Box>
          );
        })}
        <Separator 
          orientation="horizontal"
          borderColor="gray.200" 
          borderWidth="1px"
          mx="10px"
        />
      </Flex>
    
        <Box pb="20px" px="10px">
          <SidebarHelp />
        </Box>
      </Flex>
    );
}

export default SidebarContent